import {makeStyles} from "@material-ui/core";

const useStyles = makeStyles(theme => ({
    title: {
        textAlign: isMobile => isMobile ? 'center' : 'left',
        fontWeight: 'bold',
    },
}));

export default useStyles;